// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-intake-wrapper {
  max-width: 960px;
  margin: 2rem auto;
  padding: 2rem;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.05);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  min-height: 70vh; 
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

  
  .view-intake-wrapper h2 {
    text-align: center;
    margin-bottom: 2rem;
    color: var(--clr-primary-dark, #2e2e2e);
    font-size: 1.8rem;
    letter-spacing: 0.5px;
  }
  
  .view-intake-section {
    border: 1px solid #ddd;
    border-radius: 12px;
    margin-bottom: 1.75rem;
    background-color: #fafafa;
    overflow: hidden;
  }
  
  .view-intake-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.25rem;
    background-color: #e9eff4;
    cursor: pointer;
    border-bottom: 1px solid #ccc;
    transition: background-color 0.3s ease;
  }
  
  .view-intake-section-header:hover {
    background-color: #dce7f0;
  }
  
  .view-intake-section-header h3 {
    margin: 0;
    font-size: 1.1rem;
    color: #2c2c2c;
    font-weight: 600;
  }
  
  .view-intake-toggle-icon {
    font-size: 1.25rem;
    font-weight: bold;
    color: #666;
    transition: transform 0.2s ease-in-out;
  }
  
  .view-intake-fields {
    list-style: none;
    padding: 1rem 1.5rem;
    margin: 0;
    background-color: #fff;
  }
  
  .view-intake-fields li {
    padding: 0.5rem 0;
    border-bottom: 1px dashed #ddd;
    font-size: 0.95rem;
    color: #444;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  
  .view-intake-fields li strong {
    flex: 0 0 240px;
    color: #222;
    font-weight: 500;
  }
  
  .view-intake-fields li:last-child {
    border-bottom: none;
  }
  
  /* Responsive Styles */
  @media screen and (max-width: 768px) {
    .view-intake-wrapper {
      padding: 1.25rem;
    }
  
    .view-intake-section-header h3 {
      font-size: 1rem;
    }
  
    .view-intake-fields li {
      flex-direction: column;
      font-size: 0.9rem;
    }
  
    .view-intake-fields li strong {
      flex: unset;
      width: 100%;
    }
  }
  
  @media screen and (max-width: 480px) {
    .view-intake-wrapper h2 {
      font-size: 1.5rem;
    }
  
    .view-intake-section-header {
      padding: 0.8rem 1rem;
    }
  
    .view-intake-toggle-icon {
      font-size: 1.1rem;
    }
  }
  
  .no-intake-message {
    padding: 1.5rem;
    font-style: italic;
    /* color: var(--clr-grey-6); */
    font-size: 1.5rem;
    text-align: center;
    margin-top: 2rem;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/components/Scheduling/styles/ViewIntakeForm.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,4DAA4D;EAC5D,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;;EAGE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,6BAA6B;IAC7B,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,sCAAsC;EACxC;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB;MACtB,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,WAAW;IACb;EACF;;EAEA;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB","sourcesContent":[".view-intake-wrapper {\n  max-width: 960px;\n  margin: 2rem auto;\n  padding: 2rem;\n  background-color: #fff;\n  border-radius: 16px;\n  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.05);\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  min-height: 70vh; \n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n  \n  .view-intake-wrapper h2 {\n    text-align: center;\n    margin-bottom: 2rem;\n    color: var(--clr-primary-dark, #2e2e2e);\n    font-size: 1.8rem;\n    letter-spacing: 0.5px;\n  }\n  \n  .view-intake-section {\n    border: 1px solid #ddd;\n    border-radius: 12px;\n    margin-bottom: 1.75rem;\n    background-color: #fafafa;\n    overflow: hidden;\n  }\n  \n  .view-intake-section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem 1.25rem;\n    background-color: #e9eff4;\n    cursor: pointer;\n    border-bottom: 1px solid #ccc;\n    transition: background-color 0.3s ease;\n  }\n  \n  .view-intake-section-header:hover {\n    background-color: #dce7f0;\n  }\n  \n  .view-intake-section-header h3 {\n    margin: 0;\n    font-size: 1.1rem;\n    color: #2c2c2c;\n    font-weight: 600;\n  }\n  \n  .view-intake-toggle-icon {\n    font-size: 1.25rem;\n    font-weight: bold;\n    color: #666;\n    transition: transform 0.2s ease-in-out;\n  }\n  \n  .view-intake-fields {\n    list-style: none;\n    padding: 1rem 1.5rem;\n    margin: 0;\n    background-color: #fff;\n  }\n  \n  .view-intake-fields li {\n    padding: 0.5rem 0;\n    border-bottom: 1px dashed #ddd;\n    font-size: 0.95rem;\n    color: #444;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n  \n  .view-intake-fields li strong {\n    flex: 0 0 240px;\n    color: #222;\n    font-weight: 500;\n  }\n  \n  .view-intake-fields li:last-child {\n    border-bottom: none;\n  }\n  \n  /* Responsive Styles */\n  @media screen and (max-width: 768px) {\n    .view-intake-wrapper {\n      padding: 1.25rem;\n    }\n  \n    .view-intake-section-header h3 {\n      font-size: 1rem;\n    }\n  \n    .view-intake-fields li {\n      flex-direction: column;\n      font-size: 0.9rem;\n    }\n  \n    .view-intake-fields li strong {\n      flex: unset;\n      width: 100%;\n    }\n  }\n  \n  @media screen and (max-width: 480px) {\n    .view-intake-wrapper h2 {\n      font-size: 1.5rem;\n    }\n  \n    .view-intake-section-header {\n      padding: 0.8rem 1rem;\n    }\n  \n    .view-intake-toggle-icon {\n      font-size: 1.1rem;\n    }\n  }\n  \n  .no-intake-message {\n    padding: 1.5rem;\n    font-style: italic;\n    /* color: var(--clr-grey-6); */\n    font-size: 1.5rem;\n    text-align: center;\n    margin-top: 2rem;\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
